import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import {
  useTargetVisitsStore,
  type TargetMetricsSnapshot,
} from '../../store/targetVisitsStore';
import { formatTargetScopeKey } from '../../utils/target-scope.utils';
import { useSessionVisitBaseline } from '../useSessionVisitBaseline';

export function useHomeVisitBaseline({
  targetId,
  targetType,
}: {
  targetId: string | null;
  targetType: TargetTypeType;
}): {
  baselineAt: Date | null;
  isReady: boolean;
  previousSnapshot: TargetMetricsSnapshot | null;
} {
  const baseline = useSessionVisitBaseline({
    kind: 'home',
    targetId,
    targetType,
  });
  const scopeKey = targetId
    ? formatTargetScopeKey({ targetId, targetType })
    : null;
  const previousSnapshot = useTargetVisitsStore((state) =>
    scopeKey ? (state.homeSessionSnapshots[scopeKey] ?? null) : null,
  );

  return { ...baseline, previousSnapshot };
}
